module.exports = __webpack_public_path__ + "a16fe66461770772b005b309e187a03b.svg";